"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAPER_COLOR = exports.BG_COLOR = exports.LOGO_COLOR = void 0;
exports.LOGO_COLOR = "#32a0aa";
exports.BG_COLOR = "#1e1e26";
exports.PAPER_COLOR = "#2e303a";
